var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button-game',{attrs:{"name":"logar com o google","typeLogin":"social","social":"google","action":"google"}})}
var staticRenderFns = []

export { render, staticRenderFns }